import { getTextField } from '@lender/utils';
import { object } from 'yup';

import { getExpressionField } from 'utils/validation';

export const getSchema = ({ schemaParams, isNewExpressionsParsingLogicEnabled }) =>
  object().shape({
    expression: getExpressionField({
      schemaParams,
      isOnlyBooleanAllowed: true,
      isNewExpressionsParsingLogicEnabled,
    }),
    capacity: getTextField({ isRequired: true, errorText: 'Capacity can not be empty' }),
  });
